import { useState, type FC } from "react";
import { Box, Container, TextField, Autocomplete } from "@mui/material";
import DialogLayout from "../DialogLayout";
import { EmailTypes } from "src/types/emailBotPolicy";

const CreateEmailBotPolicyModal: FC<any> = (props) => {
  const {
    creditFeaturePolicies,
    isCreateEmailBotPolicyModal,
    handleCloseCreateModal,
    emailBotPolicyInput,
    handleCreateEmailBotPolicy,
    loadingStates,
    handleEmailBotPolicyInput,
    getDisplayValue,
    emailTypes,
  } = props;

  const [submitClicked, setSubmitClicked] = useState(false);
  const creditPolicyOptions =
    creditFeaturePolicies?.map((policy: any) => ({
      label: policy.title,
      id: policy.id,
    })) || [];

  return (
    <DialogLayout
      isOpen={isCreateEmailBotPolicyModal}
      onClose={handleCloseCreateModal}
      title="Create Email Bot Policy"
      action="Submit"
      handleAction={() => {
        setSubmitClicked(true);
        if (emailBotPolicyInput.title && emailBotPolicyInput.featurePolicyId) {
          handleCreateEmailBotPolicy();
        }
      }}
      isLoading={loadingStates.createEmailBotPolicy}
    >
      <>
        <Container
          sx={{
            display: "flex",
            gap: 2,
            mt: 3,
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <TextField
              label="Email Bot Policy Title"
              value={emailBotPolicyInput?.title}
              onChange={(e) =>
                handleEmailBotPolicyInput("title", e.target.value)
              }
              sx={{
                width: "100%",
                mb: 3,
              }}
              error={submitClicked && !emailBotPolicyInput.title}
              helperText={
                submitClicked && !emailBotPolicyInput.title
                  ? "Email Bot Policy title should not be empty."
                  : ""
              }
            />
            <Autocomplete
              options={creditPolicyOptions}
              getOptionLabel={(option: any) => option.label}
              onChange={(event, newValue) => {
                if (newValue) {
                  handleEmailBotPolicyInput("featurePolicyId", newValue.id);
                }
              }}
              clearIcon={null}
              noOptionsText="No Credit Feature Policies available"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Credit Feature Policy"
                  sx={{
                    width: "100%",
                    mb: 3,
                  }}
                  error={submitClicked && !emailBotPolicyInput.featurePolicyId}
                  helperText={
                    submitClicked && !emailBotPolicyInput.featurePolicyId
                      ? "You must select credit feature policy."
                      : ""
                  }
                />
              )}
            />

            <Autocomplete
              disablePortal
              id="combo-box-demo"
              value={getDisplayValue(emailBotPolicyInput.type)}
              options={emailTypes}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => option}
              onChange={(e, value) => {
                handleEmailBotPolicyInput("type", EmailTypes[value]);
              }}
              filterOptions={(options, { inputValue }) => options}
              renderInput={(params) => (
                <TextField {...params} label="Feature Type" />
              )}
            />
          </Box>
        </Container>
      </>
    </DialogLayout>
  );
};

export default CreateEmailBotPolicyModal;
